// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_TvDashboardByStepsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/tv_dashboard_by_steps
 *
 * Groups PENDING work-order steps by production step that is configured
 * for TV display (so_production_step_show_on_tv = 1). Each group has:
 *   - step: the production step metadata (id, name, description)
 *   - items: list of pending items ordered by delivery urgency
 */
import type { Orders_TvDashboardByStepsItemRow } from './Orders_TvDashboardByStepsItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_TvDashboardByStepsResponseDados {
steps: {
step: object,
items: Orders_TvDashboardByStepsItemRow[],
}[]
}

export type Orders_TvDashboardByStepsResponse = ApiResponse<Orders_TvDashboardByStepsResponseDados>;

registerResponseContract('Orders_TvDashboardByStepsResponse', {
  steps: { type: 'array',   required: true },
})
